import(/* webpackMode: "eager" */ "/workspace/apps/web/src/app/global-error.tsx");
